import React, { useState } from "react";
import "./NavBar.css";
import Logo from "../Images/new-logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome,
  faInfoCircle,
  faBoxOpen,
  faUsers,
  faHandshake,
  faComments,
  faGraduationCap
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROOT, PRODUCT, TEACHER_LOGIN } from '../Routes/Routes';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
      return;
    }

    const section = document.getElementById(sectionId);
    if (section) {
      const navbarHeight = document.querySelector('.navbar').offsetHeight;
      const offset = 30;
      const targetPosition = section.offsetTop - navbarHeight - offset;
      
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    }
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <img 
            src={Logo} 
            alt="Logo" 
            onClick={() => {
              navigate(ROOT);
              window.scrollTo(0, 0);
            }} 
          />
        </div>
        <div className="navbar-right">
          <a 
            className="donate-button" 
            onClick={() => navigate('/sponsors')}
          >
            Our Sponsors
          </a>
          <div className="navbar-toggle" onClick={() => setIsOpen(!isOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      <div className={`navbar-links ${isOpen ? "active" : ""}`}>
        <a href="#home" onClick={() => scrollToSection("home")}>
          <FontAwesomeIcon icon={faHome} className="nav-icon" /> Home
        </a>
        <a href="#about" onClick={() => scrollToSection("about")}>
          <FontAwesomeIcon icon={faInfoCircle} className="nav-icon" /> About
        </a>
        <a href="#products" onClick={() => {
          navigate(PRODUCT);
          window.scrollTo(0, 0);
          setIsOpen(false);
        }}>
          <FontAwesomeIcon icon={faBoxOpen} className="nav-icon" /> Products
        </a>
        <a href="#reviews" onClick={() => scrollToSection("reviews")}>
        <FontAwesomeIcon icon={faComments} className="nav-icon" /> Reviews
        </a>
        <a href="#team" onClick={() => scrollToSection("team")}>
          <FontAwesomeIcon icon={faUsers} className="nav-icon" /> Team
        </a>
        <a href="#supporters" onClick={() => scrollToSection("supporters")}>
          <FontAwesomeIcon icon={faHandshake} className="nav-icon" /> Our Supporters
        </a>
        <a href="/teacher/login" onClick={() => {
          navigate(TEACHER_LOGIN);
          setIsOpen(false);
        }}>
          <FontAwesomeIcon icon={faGraduationCap} className="nav-icon" /> Teacher Portal
        </a>
      </div>
    </nav>
  );
};

export default NavBar;